var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"rules":_vm.rules},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }